import "./style.css";
import { jsx as e, jsxs as o, Fragment as f } from "react/jsx-runtime";
import { useId as k, useMemo as w } from "react";
const S = "_container_14s04_1", $ = {
  container: S
}, C = 5, L = 16;
function M(t, l) {
  const r = t < Math.floor(l), n = t === Math.floor(l) && l % 1 > 0;
  return r ? "filled" : n ? "partial" : "empty";
}
function v({
  rating: t,
  decimalPrecision: l = 2,
  ariaLabel: r,
  size: n = L,
  maximumRating: a = C
}) {
  const d = k();
  if (!t || t <= 0)
    return null;
  const s = t === a ? t.toFixed(0) : t.toFixed(l), p = w(
    () => r(s, a.toString()),
    [r, s, a]
  );
  return /* @__PURE__ */ e("div", { role: "img", className: $.container, "aria-label": p, children: [...Array(5)].map((F, c) => {
    const m = M(c, t), h = `${d}-${c}`;
    return /* @__PURE__ */ e(
      _,
      {
        id: h,
        rating: t,
        type: m,
        size: n
      },
      h
    );
  }) });
}
const i = `M8 12.8355L11.9892 15.833C12.6217 16.3186 13.4811 15.6655 13.2379 14.8952L11.7135
   10.0558L15.6541 7.15876C16.3028 6.68989 15.9785 5.63491 15.1839 5.63491H10.3514L8.77839
   0.577724C8.53514 -0.192575 7.48108 -0.192575 7.23783 0.577724L5.64863 5.63491H0.816148C0.0215454 5.63491
   -0.302782 6.68989 0.345873 7.15876L4.28645 10.0558L2.76211 14.8952C2.51887 15.6655 3.37833 16.3019
   4.01077 15.833L8 12.8355Z`;
function _({ id: t, rating: l, type: r, size: n }) {
  return /* @__PURE__ */ o("svg", { width: n, height: n, viewBox: "0 0 16 16", children: [
    r === "filled" && /* @__PURE__ */ e(A, {}),
    r === "partial" && /* @__PURE__ */ e(T, { id: t, rating: l }),
    r === "empty" && /* @__PURE__ */ e(y, { id: t })
  ] });
}
function u({ id: t }) {
  return /* @__PURE__ */ o("mask", { id: `hole-${t}`, children: [
    /* @__PURE__ */ e("rect", { width: "100%", height: "100%", fill: "white" }),
    /* @__PURE__ */ e(
      "path",
      {
        d: i,
        fill: "black",
        transform: "scale(0.7) translate(3.5, 3.5)",
        stroke: "white"
      }
    )
  ] });
}
function A() {
  return /* @__PURE__ */ e("path", { d: i, fill: "#876C43", stroke: "white" });
}
function T({ id: t, rating: l }) {
  const r = l % 1 * 100;
  return /* @__PURE__ */ o(f, { children: [
    /* @__PURE__ */ o("defs", { children: [
      /* @__PURE__ */ e("mask", { id: `partial-mask-${t}`, children: /* @__PURE__ */ e("rect", { width: `${r}%`, height: "100%", fill: "white" }) }),
      /* @__PURE__ */ e(u, { id: t })
    ] }),
    /* @__PURE__ */ e(
      "path",
      {
        d: i,
        stroke: "white",
        fill: "#876C43",
        mask: `url(#partial-mask-${t})`
      }
    ),
    /* @__PURE__ */ e(
      "path",
      {
        id: `outline-${t}`,
        d: i,
        fill: "#876C43",
        mask: `url(#hole-${t})`,
        stroke: "white"
      }
    )
  ] });
}
function y({ id: t }) {
  return /* @__PURE__ */ o(f, { children: [
    /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e(u, { id: t }) }),
    /* @__PURE__ */ e(
      "path",
      {
        id: `outline-${t}`,
        d: i,
        fill: "#876C43",
        mask: `url(#hole-${t})`,
        stroke: "white"
      }
    )
  ] });
}
export {
  v as default
};
//# sourceMappingURL=StarRating.js.map
